import {
  GET_MASTER_PAYMENT_PROVIDER_LIST,
  GET_MASTER_PAYMENT_PROVIDER_LIST_SUCCESS,
  GET_MASTER_PAYMENT_PROVIDER_LIST_FAIL,
  GET_MASTER_PAYMENT_PROVIDER_DATA,
  GET_MASTER_PAYMENT_PROVIDER_DATA_SUCCESS,
  GET_MASTER_PAYMENT_PROVIDER_DATA_FAIL,
  CREATE_MASTER_PAYMENT_PROVIDER,
  CREATE_MASTER_PAYMENT_PROVIDER_SUCCESS,
  CREATE_MASTER_PAYMENT_PROVIDER_FAIL,
  UPDATE_MASTER_PAYMENT_PROVIDER,
  UPDATE_MASTER_PAYMENT_PROVIDER_SUCCESS,
  UPDATE_MASTER_PAYMENT_PROVIDER_FAIL,
  DELETE_MASTER_PAYMENT_PROVIDER,
  DELETE_MASTER_PAYMENT_PROVIDER_SUCCESS,
  DELETE_MASTER_PAYMENT_PROVIDER_FAIL,
} from "./actionType";

const initialState = {
  masterPaymentProvidersList: [],
  masterPaymentProvidersListLoading: false,
  masterPaymentProvidersListError: null,

  masterPaymentProviderData: [],
  masterPaymentProviderDataLoading: false,
  masterPaymentProviderDataError: null,

  createMasterPaymentProviderSuccess: [],
  createMasterPaymentProviderLoading: false,
  createMasterPaymentProviderError: null,

  updateMasterPaymentProviderSuccess: [],
  updateMasterPaymentProviderLoading: false,
  updateMasterPaymentProviderError: null,

  deleteMasterPaymentProviderSuccess: [],
  deleteMasterPaymentProviderLoading: false,
  deleteMasterPaymentProviderError: null,
};

const MasterPaymentProvider = (state = initialState, action) => {
  switch (action.type) {
    // Get masterPaymentProvider list
    case GET_MASTER_PAYMENT_PROVIDER_LIST:
      return {
        ...state,
        masterPaymentProvidersListLoading: true,
        masterPaymentProvidersListError: null,
      };
    case GET_MASTER_PAYMENT_PROVIDER_LIST_SUCCESS:
      return {
        ...state,
        masterPaymentProvidersList: action.payload,
        masterPaymentProvidersListLoading: false,
      };
    case GET_MASTER_PAYMENT_PROVIDER_LIST_FAIL:
      return {
        ...state,
        masterPaymentProvidersListLoading: false,
        masterPaymentProvidersListError: action.payload,
      };

    // Get single masterPaymentProvider
    case GET_MASTER_PAYMENT_PROVIDER_DATA:
      return {
        ...state,
        masterPaymentProviderDataLoading: true,
        masterPaymentProviderDataError: null,
      };
    case GET_MASTER_PAYMENT_PROVIDER_DATA_SUCCESS:
      return {
        ...state,
        masterPaymentProviderData: action.payload,
        masterPaymentProviderDataLoading: false,
      };
    case GET_MASTER_PAYMENT_PROVIDER_DATA_FAIL:
      return {
        ...state,
        masterPaymentProviderDataLoading: false,
        masterPaymentProviderDataError: action.payload,
      };

    // Create masterPaymentProvider
    case CREATE_MASTER_PAYMENT_PROVIDER:
      return {
        ...state,
        createMasterPaymentProviderLoading: true,
        createMasterPaymentProviderError: null,
      };
    case CREATE_MASTER_PAYMENT_PROVIDER_SUCCESS:
      return {
        ...state,
        createMasterPaymentProviderSuccess: action.payload,
        createMasterPaymentProviderLoading: false,
      };
    case CREATE_MASTER_PAYMENT_PROVIDER_FAIL:
      return {
        ...state,
        createMasterPaymentProviderLoading: false,
        createMasterPaymentProviderError: action.payload,
      };

    // Update masterPaymentProvider
    case UPDATE_MASTER_PAYMENT_PROVIDER:
      return {
        ...state,
        updateMasterPaymentProviderLoading: true,
        updateMasterPaymentProviderError: null,
      };
    case UPDATE_MASTER_PAYMENT_PROVIDER_SUCCESS:
      return {
        ...state,
        updateMasterPaymentProviderSuccess: action.payload,
        updateMasterPaymentProviderLoading: false,
      };
    case UPDATE_MASTER_PAYMENT_PROVIDER_FAIL:
      return {
        ...state,
        updateMasterPaymentProviderLoading: false,
        updateMasterPaymentProviderError: action.payload,
      };

    // Delete masterPaymentProvider
    case DELETE_MASTER_PAYMENT_PROVIDER:
      return {
        ...state,
        deleteMasterPaymentProviderLoading: true,
        deleteMasterPaymentProviderError: null,
      };
    case DELETE_MASTER_PAYMENT_PROVIDER_SUCCESS:
      return {
        ...state,
        deleteMasterPaymentProviderSuccess: action.payload,
        deleteMasterPaymentProviderLoading: false,
      };
    case DELETE_MASTER_PAYMENT_PROVIDER_FAIL:
      return {
        ...state,
        deleteMasterPaymentProviderLoading: false,
        deleteMasterPaymentProviderError: action.payload,
      };

    default:
      return state;
  }
};

export default MasterPaymentProvider;
